import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { PNLAnalyticsEndpoint, PNLFetchStatus } from '../../actions/pnlAnalytics';
import { PNLGoodiesNonCompletedResponses } from '../../pnlAnalytics/PaperPlaceHolder';
import { bAccFetchConnector, FetchBackAccAnalyticsPropsFromRedux } from '../dataFetcher';
import { UniqueTableName } from '../../common/uniqueTableName';
import { SimpleTableColumnConfig, TableSize } from '../../tables/types';
import { AggFuncName } from '../../common/cellRangeAgg';
import ExpandableTable, { ExpandableTableConfig } from '../../tables/ExpandableTable';
import { BACashPlanning } from '../../pnlAnalytics/fetchTypes';
import { withRouter } from 'react-router-dom';
import { numberFormat } from '../../containers/pivotHelper';
import { kFormatter, redOnly } from '../../containers/pivotHelper';
import { useDispatch } from 'react-redux';
import { Button } from '@material-ui/core';
import { clearAccDataAction } from '../../actions/pnlAnalytics';
import { useZusStore } from '../../reducers/appStore';
import TextField from '@material-ui/core/TextField';

const columns: Array<SimpleTableColumnConfig> = [
    { name: 'vessel', title: 'Vessel' },
    { name: 'lot_num', title: 'LOT' },
    { name: 'journal_date', title: 'Date' },
    { name: 'entry_id', title: 'ID' },
    { name: 'narrative', title: 'Narrative' },
    { name: 'amount', title: 'Amount', bodyTemplate: (val) => kFormatter(val, false), textColor: (val) => redOnly(val, 0) },
];

const config: ExpandableTableConfig = {
    uniqueTableName: UniqueTableName.BASCGCashReconciliation,
    title: `Bank Cash Transactions`,
    size: TableSize.Medium,
    columns: columns,
    grandTotal: true,
    aggFormatVal: (aggFuncName: AggFuncName, val: number) => {
        return aggFuncName === AggFuncName.Count ? val : numberFormat(val, 0);
    },
    pivotDepth: 2,
    defaultExpandable: 0,
    stickyHeader: true,
};

type Props = FetchBackAccAnalyticsPropsFromRedux & RouteComponentProps;

const CashRecTable = (props: Props) => {
    const {
        cashPlanningFilters: { cashStartDate, cashEndDate },
        setCashPlanningStartDateFilter,
        setCashPlanningEndDateFilter,
    } = useZusStore((state) => state);
    const dispatch = useDispatch();
    const cashPlanningData = props.pnlAnalytics.back_accounting_cash_planning;
    // Construct the config columns
    let respData = cashPlanningData.data! as BACashPlanning;

    if (cashPlanningData.status !== PNLFetchStatus.COMPLETED) {
        return (
            <PNLGoodiesNonCompletedResponses endpoint={PNLAnalyticsEndpoint.BACashPlanning} data={cashPlanningData} minHeight={'500px'} />
        );
    }
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignContent: 'center',
                gap: '20px',
                marginTop: '50px',
            }}>
            <div style={{ display: 'flex', gap: '25px' }}>
                <TextField
                    id="date"
                    label="Start Date"
                    type="date"
                    value={cashStartDate!}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    onChange={(startDate) => {
                        setCashPlanningStartDateFilter(startDate.target.value);
                    }}
                />
                <TextField
                    id="date"
                    label="End Date"
                    type="date"
                    value={cashEndDate!}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    onChange={(endDate) => {
                        setCashPlanningEndDateFilter(endDate.target.value);
                    }}
                />
                <Button
                    style={{ marginLeft: '25px' }}
                    onClick={() => {
                        dispatch(clearAccDataAction());
                    }}
                    variant="contained"
                    color="primary"
                    size={'small'}>
                    Generate Report
                </Button>
            </div>
            <ExpandableTable data={respData.scg_cash_rec} config={config} />
        </div>
    );
};

// At the bottom, wrap with both connectors:
export default withRouter(bAccFetchConnector(CashRecTable));
